import { apiClient } from '@/config/api';
import { ApiResponse } from '@/types/status';

export interface Author {
    _id: string;
    name: string;
    image?: string;
    info?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface CreateAuthorDto {
    name: string;
    image?: string;
    info?: string;
}

export interface UpdateAuthorDto extends Partial<CreateAuthorDto> {}

export interface GetPaginationAuthorsDto {
    page?: number;
    limit?: number;
    search?: string;
}

const AUTHOR_ENDPOINTS = {
    AUTHORS: '/authors',
    BY_ID: (id: string) => `/authors/${id}`,
};

export const authorService = {
    create(data: CreateAuthorDto | FormData): Promise<ApiResponse<any>> {
        return apiClient.post(AUTHOR_ENDPOINTS.AUTHORS, data as any);
    },
    findAll(query: GetPaginationAuthorsDto): Promise<ApiResponse<any>> {
        return apiClient.get(AUTHOR_ENDPOINTS.AUTHORS, query);
    },
    findOne(id: string): Promise<ApiResponse<any>> {
        return apiClient.get(AUTHOR_ENDPOINTS.BY_ID(id));
    },
    update(id: string, data: UpdateAuthorDto | FormData): Promise<ApiResponse<any>> {
        return apiClient.put(AUTHOR_ENDPOINTS.BY_ID(id), data as any);
    },
    remove(id: string): Promise<ApiResponse<any>> {
        return apiClient.delete(AUTHOR_ENDPOINTS.BY_ID(id));
    },
};


